export const V2_GOVERNANCE_STATUSES = ["draft", "active", "retired"] as const;

export const V2_LANE_KEYS = [
  "EDGE_CHAIRMAN",
  "EDGE_MD_OFFICE",
  "BOARD_EXCOM",
  "SDF_MD",
] as const;

export const V2_PRIORITY_KEYS = ["P1", "P2", "P3", "P4"] as const;


export const V2_DOC_TYPES = [
  "MEMO",
  "TERM_SHEET",
  "LEGAL_OPINION",
  "BOARD_PAPER",
  "PRESENTATION",
  "CORRESPONDENCE",
  "REPORT",
  "OTHER",
] as const;

export const V2_MEETING_TYPES = [
  "BOARD",
  "IC",
  "EXCOM",
  "SHAREHOLDER",
  "CHAIRMAN",
  "OTHER",
] as const;

export const V2_PHASE_KEYS = [
  "REGISTRATION",
  "IN_PROGRESS",
  "REVIEW",
  "SIGNOFF",
  "CLOSED",
] as const;

export const V2_ROLE_KEYS = [
  "PMO",
  "OWNER",
  "REVIEWER",
  "SIGNOFF_AUTHORITY",
  "VIEWER",
] as const;

export const V2_REFERENCE_LIST_KEYS = [
  "PRIORITY",
  "DOC_TYPE",
  "MEETING_TYPE",
  "DELAY_REASON",
] as const;

export const V2_DELAY_REASON_SEEDS = [
  { itemKey: "AWAITING_THIRD_PARTY", label: "Awaiting third-party / external response", sortOrder: 1 },
  { itemKey: "AWAITING_SENIOR_REVIEW", label: "Awaiting senior review (incl. SDF MD meeting)", sortOrder: 2 },
  { itemKey: "AWAITING_TEAM_INPUT", label: "Awaiting input from another team member", sortOrder: 3 },
  { itemKey: "RESOURCE_UNAVAILABLE", label: "Resource unavailable / capacity", sortOrder: 4 },
  { itemKey: "SCOPE_CHANGED", label: "Scope changed mid-task", sortOrder: 5 },
  { itemKey: "OTHER", label: "Other", sortOrder: 99 },
] as const;

export const V2_ACTION_ITEM_STATUSES = [
  "REGISTERED",
  "IN_PROGRESS",
  "WITH_SDF_MD_REVIEW",
  "WITH_EDGE_MD_REVIEW",
  "WITH_SECRETARIAT_TO_SEND",
  "AWAITING_DISPATCH",
  "SENT_UPWARD",
  "AWAITING_RESPONSE",
  "SIGNED_OFF",
  "CLOSED",
  "CANCELLED",
] as const;

export type V2ActionItemStatus = (typeof V2_ACTION_ITEM_STATUSES)[number];

export const V2_ALLOWED_TRANSITIONS: Record<V2ActionItemStatus, V2ActionItemStatus[]> = {
  REGISTERED: ["IN_PROGRESS", "CLOSED", "CANCELLED"],
  IN_PROGRESS: ["WITH_SDF_MD_REVIEW", "WITH_EDGE_MD_REVIEW", "WITH_SECRETARIAT_TO_SEND", "CLOSED", "CANCELLED"],
  WITH_SDF_MD_REVIEW: ["AWAITING_DISPATCH", "WITH_EDGE_MD_REVIEW", "WITH_SECRETARIAT_TO_SEND", "CLOSED", "IN_PROGRESS", "CANCELLED"],
  WITH_EDGE_MD_REVIEW: ["WITH_SECRETARIAT_TO_SEND", "CLOSED", "IN_PROGRESS", "CANCELLED"],
  WITH_SECRETARIAT_TO_SEND: ["SENT_UPWARD", "CLOSED", "IN_PROGRESS", "CANCELLED"],
  AWAITING_DISPATCH: ["SENT_UPWARD", "IN_PROGRESS", "CANCELLED"],
  SENT_UPWARD: ["CLOSED"],
  AWAITING_RESPONSE: ["SIGNED_OFF", "CLOSED", "IN_PROGRESS", "CANCELLED"],
  SIGNED_OFF: ["CLOSED"],
  CLOSED: [],
  CANCELLED: [],
};

export const V2_GOVERNANCE_CONTROLLED_DESTINATIONS: V2ActionItemStatus[] = [
  "WITH_SDF_MD_REVIEW",
  "WITH_EDGE_MD_REVIEW",
  "WITH_SECRETARIAT_TO_SEND",
  "AWAITING_DISPATCH",
  "SENT_UPWARD",
  "SIGNED_OFF",
];

export const V2_STATUS_LABELS: Record<V2ActionItemStatus, string> = {
  REGISTERED: "Registered",
  IN_PROGRESS: "In Progress",
  WITH_SDF_MD_REVIEW: "With SDF MD Review",
  WITH_EDGE_MD_REVIEW: "With EDGE MD Review",
  WITH_SECRETARIAT_TO_SEND: "With Secretariat to Send",
  AWAITING_DISPATCH: "Awaiting Dispatch",
  SENT_UPWARD: "Sent Upward",
  AWAITING_RESPONSE: "Awaiting Response",
  SIGNED_OFF: "Signed Off",
  CLOSED: "Closed",
  CANCELLED: "Cancelled",
};

export const V2_EVENT_TYPES = [
  "REGISTERED",
  "PROGRESS_UPDATE",
  "STATUS_CHANGED",
  "RETURNED_FOR_AMENDMENTS",
  "SIGNOFF_GRANTED",
  "MD_APPROVED",
  "DISPATCHED_UPWARD",
  "FIELD_UPDATED",
  "ESCALATION_REQUESTED",
  "ESCALATION_RESOLVED",
] as const;

export const UPWARD_DISPATCH_TARGET_WORKING_DAYS = 2;

export const ABOVE_MD_LANE_KEYS: readonly string[] = ["EDGE_CHAIRMAN", "EDGE_MD_OFFICE", "BOARD_EXCOM"] as const;
